<template>
  <div class="dashboard-wrapper" v-if="serverData.length">
    <div class="row">
      <div
        class="col-12 col-md-6 col-lg-4"
        v-for="(item, index) in serverData[0]"
        :key="index"
      >
        <div
          class="h-100 px-5 py-4 px-sm-9 py-sm-5 shadow-sm rounded-lg bg-white"
        >
          <v-card-title
            class="text-h6 font-weight-bold px-0 card-title mb-0 d-flex justify-content-between align-items-center"
          >
            <div>{{ item.title }}</div>
            <div>
              <span
                @click="() => handlerFilter(item.totalFilters, item.total)"
                class="badge badge-light-info px-5 py-3 cursor-pointer"
                >{{ item.total }}</span
              >
            </div>
          </v-card-title>

          <div class="table-responsive table-operation">
            <table class="table">
              <thead>
                <tr v-if="item?.counters">
                  <th
                    scope="col"
                    v-for="header in getHeaders(item.counters)"
                    :key="header.value"
                  >
                    {{ header.text }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(counter, index) in item.counters"
                  :key="index"
                  :class="[getBorderClass(index, item.counters.length)]"
                >
                  <template v-if="item.counters.length">
                    <th scope="row" class="font-weight-medium">
                      {{ counter.title }}
                    </th>

                    <td
                      @click="
                        () => handlerFilter(counter?.sddFilters, counter.sdd)
                      "
                      class="font-weight-medium text-dark-50 text-center"
                      :class="[
                        {
                          'cursor-pointer': !Array.isArray(counter?.sddFilters),
                        },
                      ]"
                    >
                      {{ counter.sdd }}
                    </td>
                    <td
                      @click="
                        () => handlerFilter(counter?.nddFilters, counter.ndd)
                      "
                      class="font-weight-medium text-dark-50 text-center"
                      :class="[
                        {
                          'cursor-pointer': !Array.isArray(counter?.nddFilters),
                        },
                      ]"
                    >
                      {{ counter.ndd }}
                    </td>
                    <td
                      @click="
                        () => handlerFilter(counter?.b2bFilters, counter.b2b)
                      "
                      class="font-weight-medium text-dark-50 text-center"
                      :class="[
                        {
                          'cursor-pointer': !Array.isArray(counter?.b2bFilters),
                        },
                      ]"
                    >
                      {{ counter.b2b }}
                    </td>
                    <td
                      @click="
                        () =>
                          handlerFilter(
                            counter?.crossDockFilters,
                            counter.crossDock
                          )
                      "
                      class="font-weight-medium text-dark-50 text-center"
                      :class="[
                        {
                          'cursor-pointer': !Array.isArray(
                            counter?.crossDockFilters
                          ),
                        },
                      ]"
                    >
                      {{ counter.crossDock }}
                    </td>

                    <td
                      v-if="counter?.line_total"
                      class="font-weight-medium text-center"
                      :class="[
                        {
                          'cursor-pointer': !Array.isArray(
                            counter?.line_total_filters
                          ),
                        },
                      ]"
                      @click="
                        () =>
                          handlerFilter(
                            counter?.line_total_filters,
                            counter.line_total
                          )
                      "
                    >
                      <span
                        class="badge badge-light-secondary px-2 py-2 text-black-50"
                        >{{ counter.line_total }}</span
                      >
                    </td>
                  </template>
                  <template v-else>
                    <td
                      class="font-weight-medium text-dark-50"
                      colspan="12"
                      style="padding-top: 2.5rem; text-align: center"
                    >
                      No data available
                    </td>
                  </template>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  SET_TABLE_FILTER,
  UPDATE_TABLE_STRUCTURE,
  UPDATE_TABLE_DATA,
  SET_TABLE_DATA,
} from "@/core/services/store/orders.module";
import { SET_FILTERS_DATA } from "@/core/services/store/filter.module";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
export default {
  name: "DashboardOperationGroupNew",
  props: ["serverData"],
  computed: {
    headers() {
      return [
        { text: "Title", value: "title" },
        { text: "SDD", value: "sdd" },
        { text: "NDD", value: "ndd" },
        { text: "B2B", value: "b2b" },
        { text: "XDOCK", value: "crossDock" },
      ];
    },
    filterAllData() {
      return this.$store.getters.getFiltersData;
    },
  },
  methods: {
    getHeaders(counters) {
      if (counters.find((counter) => counter?.hasOwnProperty("line_total"))) {
        return [
          { text: "Title", value: "title" },
          { text: "SDD", value: "sdd" },
          { text: "NDD", value: "ndd" },
          { text: "B2B", value: "b2b" },
          { text: "XDOCK", value: "crossDock" },
          { text: "Total", value: "line_total" },
        ];
      }

      return this.headers;
    },
    handlerFilter(filters, filterType = null) {
      if (Array.isArray(filters) || filterType === "0") return;

      this.$store.commit(SET_PAGE_LOADING, true);
      let readyFilter = [];

      Object.entries(filters).forEach((filter) => {
        if (
          filter[0] != null &&
          filter[1] != null &&
          filter[1] != undefined &&
          filter[1].length !== 0
        ) {
          if (filter[0] !== "date_range") {
            readyFilter.push({ name: filter[0], value: filter[1] });
          } else if (filter[0] === "date_range") {
            readyFilter.push(
              {
                name: "date_range.date",
                value: [filter[1].from, filter[1].to],
              },
              { name: "date_range.select", value: filter[1].type }
            );
          }
        }
      });

      this.$store.commit(SET_FILTERS_DATA, readyFilter);

      this.setOrdersTableFiltersValues(readyFilter);
    },
    async setOrdersTableFiltersValues(val) {
      this.$store.commit(SET_TABLE_FILTER, val);

      this.updateOrdersTable().then(async () => {
        await this.$router.push({
          name: "fulfillment.orders",
          params: { isFromDashboard: true },
        });
      });
      // this.$store.commit(SET_TABLE_DATA, {});
      // await this.$router.push({
      //   name: "fulfillment.orders",
      //   params: { isFromDashboard: true },
      // });
    },
    async updateOrdersTable() {
      const tableStructurePromise = this.$store.dispatch(
        UPDATE_TABLE_STRUCTURE,
        {}
      );
      const tableDataPromise = this.$store.dispatch(
        UPDATE_TABLE_DATA,
        this.$store.getters.getORDERSTableState
      );

      await Promise.all([tableStructurePromise, tableDataPromise]);
      this.$store.commit(SET_PAGE_LOADING, false);
    },
    getBorderClass(index, length) {
      return index < length - 1 ? "border-bottom-dashed" : "";
    },
  },
};
</script>

<style scoped lang="scss">
.dashboard-wrapper {
  padding: 1rem;

  @media (min-width: 768px) {
    padding: 2rem;
  }
}

/* Optional: custom table tweaks */
.custom-table {
  thead {
    background-color: #f5f5f5;
    font-weight: 600;
  }
  td {
    font-size: 0.9rem;
  }
}

.table {
  thead {
    tr {
      th {
        border-bottom: 2px dashed #ebedf3 !important;
        color: #c9cdd9 !important;
        font-size: 14px !important;
      }
    }
  }
  tbody {
    tr {
      td,
      th {
        font-size: 14px !important;
      }
    }
  }
}

.border-bottom-dashed {
  border-bottom: 1px dashed #ebedf3 !important;
}
.card-title {
  color: #7e8299 !important;
}
.table-operation {
  thead {
    tr > *:not(:first-child) {
      text-align: center !important;
    }
    tr {
      th {
        color: #8950fcff !important;
      }
    }
  }
}

.table-operation {
  tbody {
    tr > th,
    td {
      vertical-align: middle !important;
      line-height: 1 !important;
      height: 42px !important;
    }
  }
}
</style>
